// extracted by mini-css-extract-plugin
module.exports = {"easilGrayXXXLight":"#E2E5E8","easilGrayXDark":"#57595D","easilGray":"#8f9295","easilGrayXLight":"#D1D4D6","easilBlack":"#2c2e2f"};